<template>
  <PageWrapper
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_MY_ACTIVE_PUBLICATIONS"
    title="Active Publications"
    :breadcrumbs="breadcrumbs"
    page-name="Active Publications"
    align="left"
    width="full"
    action-button-text="Create New Publication"
    @click:action="navigateToCreatePublication"
  >
    <SmartFeed
      :pinia-store="useActivePublicationFeedStore"
      default-entity-layout="cardSmall"
      default-smart-feed-layout="grid"
      load-more-behavior="auto"
    />
  </PageWrapper>
</template>

<script>
import { mapState } from "pinia";
import PageWrapper from "@/components/PageWrapper.vue";
import SmartFeed from "SmartFeed/components/SmartFeed";
import { PAGE_MY_ACTIVE_PUBLICATIONS, SECTION_PUBLICATIONS } from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useActivePublicationFeedStore } from "SmartFeed/stores/feed/active-publication-feed-store";
import { useCollaboratingPublicationFeedStore } from "SmartFeed/stores/feed/collaborating-publication-feed-store";

export default {
  name: "MyActivePublications",
  components: {
    SmartFeed,
    PageWrapper,
  },
  provide: {
    hideBadge: true,
  },
  data() {
    return {
      SECTION_PUBLICATIONS,
      PAGE_MY_ACTIVE_PUBLICATIONS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "orgId",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
      ];
    },
  },
  methods: {
    useActivePublicationFeedStore,
    useCollaboratingPublicationFeedStore,
    navigateToCreatePublication() {
      window.location = `/publication/org/${this.orgId}/create`;
    },
  },
};
</script>
